<template>
    <a-list-item :id="`p${comment.id}`">
        <a-list-item-meta class="item-meta">
            <div slot="avatar" class="avatar-container">
                <span class="comment-label">#{{ comment.id }}:</span>
                <user-link :name="comment.author.name" :id="comment.author.id"/>
                <slot name="header"></slot>
            </div>
            <div slot="description" class="main">
                <div class="content">
                    <p v-html="content" class="renderText"></p>
                    <p class="bottom">
                        发表于 {{ formatDate(comment.timestamp) }}
                        <span v-if="comment.edittime != 0">
                            | 最后编辑于 {{ formatDate(comment.edittime) }}
                        </span>
                        <slot></slot>
                    </p>
                </div>
                <slot name="append"></slot>
            </div>
        </a-list-item-meta>
    </a-list-item>
</template>

<script>
import UserLink from '@/components/UserLink.vue';
import { formatTime, parseText } from '../../../utils/utils';

export default {
    props: {
        comment: Object,
    },
    computed: {
        content() {
            return parseText(this.comment.comment);
        },
    },
    methods: {
        formatDate(timestamp) {
            return formatTime(timestamp);
        },
    },
    components: {
        UserLink,
    }
}
</script>

<style lang="less" scoped>
.avatar-container {
    display: flex;
    width: 100%;
    .comment-label {
        font-size: 16px;
        font-family: Consolas;
    }
    .user-link {
        margin-left: 10px;
    }
    align-items: baseline;
    margin-bottom: 5px;
}
.main {
    .content {
        display: flex;
        flex-direction: column;
        text-align: left;
    }
    .bottom {
        margin-top: auto;
        margin-bottom: 0;
        text-align: right;
    }
    .ant-btn {
        span {
            margin: 0px;
        }
        padding: 0 6px;
    }
}
.renderText {
    color: #444444;
    font-size: 16px;
    margin: 0;
    cursor: auto;
    img {
        max-width: 100%;
    }
    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
        p {
            margin: 10px 0;
            line-height: 1.5;
        }
    }
    overflow-wrap: anywhere;
}
</style>

<style lang="less">
.ant-list-item-meta {
    flex-direction: column;
    @media screen and (max-width: 599px) {
        .content {
            margin-left: 10px;
        }
    }
}
.ant-list-item-meta-avatar {
    a {
        font-size: 14px;
    }
}
.ant-list-item-meta-content {
    width: 100%;
}
.ant-modal-mask, .ant-modal-wrap {
    z-index: 10001 !important;
}
</style>
